import { FunctionalComponent } from 'preact'
import classNames from 'classnames'

export interface BoxWidgetProps {
  className?: string
  contentClassName?: string
}

const BoxWidget: FunctionalComponent<BoxWidgetProps> = ({ className, contentClassName, children }) => (
  <div className={classNames('box', 'widget', className)}>
    <div className={classNames('box__content', 'box__pad', contentClassName)}>
      {children}
    </div>
  </div>
)

export default BoxWidget
